import Base2Repository from "./base2.repository";
import { GenericPersistence } from "core/data/persistence";
import { GenericService } from "core/data/service";

class PaymentsReportRepository extends Base2Repository {
  getPersistenceProvider() {
    return new GenericPersistence(this.getEntityIdentifier());
  }

  getServiceProvider() {
    return new GenericService({});
  }

  async getSummaryPayment(filters) {
    const result = await this.get("/v1/payments_totals_reports", {
      company_uuid: filters.company_uuid,
      from: filters.from,
      to: filters.to
    });
    return result;
  }

  async getResultPayment(filters) {
    const result = await this.get("/v1/payments_reports", {
      company_uuid: filters.company_uuid,
      from: filters.from,
      to: filters.to,
      type: filters.custom ? null : filters.type,
      page: filters.page,
      count: filters.count || 25,
      order: filters.order,
      other_payment_uuid: filters.custom,
      in_cash: filters.in_cash
    });
    return result;
  }
}

export default new PaymentsReportRepository();



// WEBPACK FOOTER //
// ./src/core/repository/payments-report.repository.js